// :cow: Cosmose CONFIDENTIAL :iso:
import { authLoginByCredentialsSuccess, authLoginSuccess, authLogout, userRestored } from './auth.actions';
import { initialState } from './auth.state';
import { ExternalPartner } from '@med/app/auth/model';
import { createReducer, on } from '@ngrx/store';


export const authReducer = createReducer(
  initialState,
  on(authLoginSuccess, (state, action) => ({
    ...state,
    profile: {
      ...action.profile,
      isAccountManager: action.profile.authorities.includes('cmp:campaign:support') || action.profile.authorities.includes('cmp:campaign:sps-support'),
      externalPartner: action.profile.authorities.includes('cmp:campaign:sps-support') ? ExternalPartner.SPS : ExternalPartner.NONE,
    },
  })),
  on(authLogout, () => ({...initialState})),
  on(authLoginByCredentialsSuccess, (state) => ({...state})),
  on(userRestored, (state, action) => ({...initialState, profile: action.profileDto})),
);
